import React, { useState } from "react";

import { TabLayoutProps } from "./TabLayout.model";
import { Accordion } from "@companion-core/shared/app/Components/Accordion";

import "@companion-core/web/src/Assets/Styles/scss/tabLayout.scss";

export const TabLayout = ({ cards }: TabLayoutProps) => {
  const [focusedCard, setFocusedCard] = useState<string | null>();

  return (
    <div className="tab-layout">
      <div className="tab-layout__accordions">
        {cards.map((card) => (
          <Accordion
            key={card.id}
            testID={card.id}
            description={card.description}
            title={card.title}
            expanded={focusedCard === card.id}
            onClick={(expanded) => expanded && setFocusedCard(card.id)}
            className="tab-layout__accordion"
          />
        ))}
      </div>
    </div>
  );
};
